import { render, staticRenderFns } from "./ClassroomDetails.vue?vue&type=template&id=45a0eae4"
import script from "./ClassroomDetails.vue?vue&type=script&lang=js"
export * from "./ClassroomDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports